module.exports = __webpack_public_path__ + "img/heartsArrows-2.ddb1373.png";